import React from 'react';

export interface ProgressDashboardMiniatureChartContainerProps {
  minHeightClass: string;
}

export const ProgressDashboardMiniatureChartContainer: React.FC<ProgressDashboardMiniatureChartContainerProps> =
  ({ children, minHeightClass }) => {
    return (
      <div className={`flex justify-center items-center pt-3 ${minHeightClass}`}>{children}</div>
    );
  };

export default ProgressDashboardMiniatureChartContainer;
